import $ from 'jquery'

import '../../../scss/app/seasonal_disconnect_form.scss'

//
// Address Change
//

const $addressChange = $('input[name="seasonal_disconnect[addressChange]"]')
const $ifAddressChange = $('.js-if-address-change')

function handleAddressChange() {
  if ($addressChange.filter(':checked').val() === '1') {
    $ifAddressChange.show()
  } else {
    $ifAddressChange.hide()
  }
}

handleAddressChange()
$addressChange.on('click', handleAddressChange)

//
// Conditional items
//

const $ifDisconnectPhone = $('.if-disconnect-telephone')
const $ifDisconnectInternet = $('.if-disconnect-internet')
const $ifDisconnectTv = $('.if-disconnect-tv')
const $disconnect = $('input[name="seasonal_disconnect[services][]"]')

function handleDisconnect() {
  $ifDisconnectPhone.hide()
  $ifDisconnectInternet.hide()
  $ifDisconnectTv.hide()

  $disconnect.filter(':checked').each((_, checkbox) => {
    const $checkbox = $(checkbox)
    const val = $checkbox.val()

    if (val === 'Telephone') {
      $ifDisconnectPhone.show()
    } else if (val === 'Internet') {
      $ifDisconnectInternet.show()
    } else if (val === 'TV') {
      $ifDisconnectTv.show()
    }
  })
}

handleDisconnect()
$disconnect.on('click', handleDisconnect)

//
// SkyChange
//

const skyChangeOptions = document.querySelectorAll('.skychange-option')

function handleSkyChangeOptions() {
  skyChangeOptions.forEach((option) => {
    const input = option.querySelector('input')
    if (input.checked) {
      option.classList.add('selected')
    } else {
      option.classList.remove('selected')
    }
  })
}

handleSkyChangeOptions()

skyChangeOptions.forEach((option) => {
  option.addEventListener('click', () => {
    const input = option.querySelector('input')
    input.checked = true
    handleSkyChangeOptions()
  })
})
